// biome-ignore lint/style/noRestrictedImports: Importiamo il tipo originale da Ant perché è da qui che esportiamo la nostra versione custom di Dropdown
import { Dropdown as AntDropdown, type DropdownProps } from 'antd';

export interface IDropdownProps extends DropdownProps {}

/**
 * Dropdown modificato per supportare gli attributi ARIA
 */
export function Dropdown(props: IDropdownProps) {
  const { ...otherProps } = props;

  return <AntDropdown trigger={['click']} autoFocus {...otherProps} />;
}
